import { twMerge } from "tailwind-merge";
import { ReactComponent as InfoIcon } from "../assets/icons/info.svg";
import { Tooltip } from "react-tooltip";

export function TooltipView({ content, id, className, containerClassName = "", icon, noArrow = false, iconClassName = "" }: { content: string | React.ReactNode, id: string, className?: string, containerClassName?: string, icon?: React.ReactNode, noArrow?: boolean, iconClassName?: string }) {
    return (
        <div data-tooltip-id={`days-view-my-tooltip-${id}`} className={containerClassName}>
            {icon ? icon : <InfoIcon className={iconClassName} />}
            <Tooltip
                id={`days-view-my-tooltip-${id}`}
                className={twMerge("max-w-[400px] flex flex-col gap-1 z-[2] !border border-[#D6D6D6] !text-black/60 !text-sm !rounded-md !p-[11px] !opacity-[1] !bg-white !shadow-[0px_4px_6px_0px_rgba(0,0,0,0.12)]", className)}
                noArrow={noArrow}
                place="top-start"
            >
                {content}
            </Tooltip>
        </div>
    );
}
